module.exports = {
      id: "ic-trend-light-usage",
      viewBox: "0 0 17 16",
      url: __webpack_public_path__ + "sprite-2c53a1.smartcharts.svg#ic-trend-light-usage",
      toString: function () {
        return this.url;
      }
    }